import get from 'lodash/get';
import React from 'react';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { withProvider } from '../../../gql/withProvider';
import { GovernmentInsuranceModal } from './GovernmentInsuranceModal';

const GovernmentInsuranceModalWithState = (props) => {
    const stateCode = get(props, ['location', 'state'], null);
    const { onCancelClick, sendMetric, locationId, providerId } = props;

    return (
        <GovernmentInsuranceModal
            onCancelClick={onCancelClick}
            providerId={providerId}
            locationId={locationId}
            sendMetric={sendMetric}
            stateCode={stateCode}
        />
    );
};

const GovernmentInsuranceModalWithApollo = withProvider(
    GovernmentInsuranceModalWithState
);

const GovernmentInsuranceModalWithMetrics = withCustomMetrics({
    element: 'GovernmentInsuranceModal',
    component: 'GovernmentInsuranceModal',
})(GovernmentInsuranceModalWithApollo);

export { GovernmentInsuranceModalWithMetrics as GovernmentInsuranceModalContainer };
